/* src/app/shared/components/mentor-assignment-editor/mentor-assignment-editor.component.scss */
td.mat-mdc-cell:first-of-type,
td.mat-mdc-footer-cell:first-of-type,
th.mat-mdc-header-cell:first-of-type {
  padding-left: 0px;
}
.hyperlink-cell {
  color: mediumblue;
  text-decoration: underline;
  cursor: pointer;
}
.normal-cell {
  color: black;
  cursor: default;
  text-decoration: none;
}
.missingEmailAddres {
  color: #B62A39;
}
.mentorAssignment--left {
  padding: 1.5rem 0 0 0;
  display: flex;
}
.mentorAssignment--right {
  display: flex;
  justify-content: space-between;
}
.mentorAssignment--button .mentorAssignment--button__icon {
  margin-right: 4px;
}
.mentorAssignment--button .mentorAssignment--end__button__icon {
  margin-right: 4px;
  margin-bottom: 3px;
}
.mentorAssignment--message {
  margin-right: 10px;
}
.mentorAssignmentFormContainer .mentorListContainer {
  display: block;
  margin-top: 1rem;
  min-width: 550px;
  margin-left: 50px;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorListContainer--label {
  display: inline;
  font-weight: 500;
  font-size: 20px;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorListContainer--selectedCampusName {
  margin-bottom: 1rem;
  border-bottom: 1px solid lightgray;
  padding-bottom: 0.2rem;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList {
  height: 22em;
  overflow-y: scroll;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem {
  margin: 0.5rem 0;
  padding: 1rem 0;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .listRow {
  display: flex;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .listRow .listDetailLeft {
  width: 25rem;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .listRow .listDetailRight .editMentorContainer--button {
  justify-content: right;
  top: 1.2rem;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .listRow .listDetailRight .editMentorContainer--button .editMentorContainer--button__icon {
  color: #A3A3A3;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .listRow .listDetailRight .editMentorContainer--button .editMentorContainer--button__icon:hover {
  color: #A3A3A3;
  background-color: white;
  border-radius: 50%;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  height: 30px;
  width: 30px;
  padding-top: 0.4rem;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem matListItemLine {
  white-space: nowrap;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .mentorListItem--mentorName {
  font-weight: 600;
  display: inline-block;
  min-width: 14em;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .mentorListItem--teaId {
  padding-left: 1.5rem;
  display: inline-block;
  min-width: 14em;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .mentorListItem--mentorEmail mat-icon {
  vertical-align: middle;
  color: #A3A3A3;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .mentorListItem--mentorEmail .mentorListItem--mentorEmail__icon {
  font-weight: 100;
  font-size: 1.2rem;
}
.mentorAssignmentFormContainer .mentorListContainer .mentorList .mentorListItem .mentorListItem--certArea {
  padding-left: 1.5rem;
  display: inline-block;
  width: 35em;
  font-size: 0.9em;
}
.mentorAssignmentFormContainer .mentorListContainer .newMentorSection {
  text-align: center;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-right: 2rem;
}
.mentorAssignmentFormContainer .mentorListContainer .newMentorSection .newMentorSection--button {
  margin: 0;
  width: 15rem;
}
.mentorAssignmentFormContainer .mentorListContainer .noMentors {
  width: 37rem;
  height: 22em;
}
.mentorAssignmentFormContainer .mentorListContainer .noMentors .noMentors--label {
  display: block;
  margin: 1rem 0 0 0;
  font-weight: 500;
  font-size: 20px;
}
.mentorAssignmentFormContainer .mentorListContainer .noMentors .noMentors--selectedCampusName {
  margin-bottom: 1rem;
  border-bottom: 1px solid lightgray;
  padding-bottom: 0.2rem;
}
.mentorAssignmentFormContainer .mentorListContainer .noMentors .noMentors--message {
  font-weight: 600;
}
.mentorAssignmentFormContainer .selectedCampusMentorFields {
  padding: 1rem 0 1em 2em;
}
.mentorAssignmentFormContainer .startDateField {
  padding: 1rem 0 1em 2em;
}
.list-row {
  display: flex;
  flex-direction: row;
}
.edit-icon {
  margin-left: auto;
  margin-right: 1em;
}
.formFields {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  z-index: 1;
}
.formFields--rightSide {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-left: 50px;
  justify-content: space-between;
}
.formFields--rightSide .formFields--contact-name {
  display: block;
  height: 20px;
}
.formFields--rightSide .formFields--rightSide--field {
  padding-bottom: 0.5rem;
}
.formFields--rightSide .saveAndCancelButtons {
  display: flex;
  white-space: nowrap;
  vertical-align: bottom;
  padding: 1rem 0 1em 2em;
  bottom: 0;
  right: 0;
  margin-bottom: 10px;
}
.formFields--rightSide .saveAndCancelButtons button {
  width: 100px;
}
.formFields--rightSide .saveAndCancelButtons button:not(:first-child) {
  margin-left: 2em;
}
.formFields--contactEditorContainer {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 50px;
}
fieldset {
  margin-top: 0.75rem;
}
fieldset mat-form-field {
  width: 100%;
}
.mentor-assignment-editor-container {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}
tr.mentor-assignment-row {
  height: 0;
}
.no-assigned-mentors-message {
  margin-top: 15px;
}
.mentor-email-cell {
  width: 300px;
}
.mentor-fee-cell {
  width: 110px;
}
.needs-principal-attestation-link {
  text-decoration: underline;
  color: mediumblue;
  cursor: pointer;
}
.formFields--rightSide--field {
  display: flex;
}
.needsPrincipalAttestationContainer {
  margin: 1.5rem;
}
.missing__cert__Areas {
  color: red;
  margin-left: 1em;
  font-size: 0.9em;
}
.mentorAssignment__campus__mismatch {
  color: red;
  font-weight: bold;
}
/*# sourceMappingURL=mentor-assignment-editor.component.css.map */
